import { Subject } from 'rxjs';
import { filter, map, bufferTime } from 'rxjs/operators';
import pako from 'pako';
import EventEmitter from 'eventemitter3'
import { NORMAL_SUBSCRIBE_MAP, WORKER_MSG_TOPIC } from './workerConfig'
import { getScopeToken, ScopeEnum } from '~/frontend-shared/helper/login-util';

const domain_env = import.meta.env.VITE_DOMAIN_ENV;

class WsSubject extends EventEmitter {
  retryTimes: number;
  subjectMap: Map<any, any>;
  subject: Subject<unknown>;
  ws!: WebSocket;
  heartBeat: any;
  connectTimer: any;
  token: string | null;

  constructor() {
    super();
    this.retryTimes = 0;
    this.subjectMap = new Map();
    this.subject = new Subject();
    this.token = null;
  }
  close() {
    this.ws.close();
  }
  connect() {
    const { $curHost } = useNuxtApp();

    const  url = $curHost.wsUrl + '/user/'

    this.ws = new WebSocket(url);
    this.ws.binaryType = 'arraybuffer';
    

    if (this.heartBeat) {
      clearTimeout(this.heartBeat);
      this.heartBeat = null
    }

    this.ws.onclose = (event) => {  
      this.reconnect()
    }
    this.ws.onerror = (event) => {
      console.log('ws:onerror', event);
      this.ws?.close()
    }
    this.ws.onopen = async () => {
      this.retryTimes = 0;
      // open 订阅
      if(!this.token){
        this.token = await getScopeToken(ScopeEnum.WS);
        if(!this.token){
          console.error("un login, error in ws");
          return;
        }
      }
      
      for (const [subTitle, subItems] of this.subjectMap) {
        
        subItems.forEach((subData: any) => {
          this.send({
            subscribe: subTitle,
            ...subData,
            token: this.token,
          })
        })
      }
    }
    this.ws.onmessage = (event) => {
      this.initHeartBeat();
      if (event.data) {
        try {
          let wsres
          if (event.data.search && event.data.replace) {
            try {
              wsres = JSON.parse(event.data)
            } catch (e) {
              return
            }
          } else {
            wsres = pako.inflateRaw(event.data, {
              to: 'string',
            })
            wsres = JSON.parse(wsres)
          }
          
          if (wsres.code !== undefined && +wsres.code !== 0) {
            if (wsres.code === -8102) {
              // 重复订阅，允许；
            }
            if (wsres.code === -8107) {
              // 限频
              this.retryTimes = 3;
            }
            if (wsres?.code === -8105) {
              // wsres 无限-8105
              const {subscribe, token, ...rest} = wsres;
              
              // token过期 重新获取
              getScopeToken(ScopeEnum.WS).then((token:string) => {
                console.log('token', token) // Log the token for debugging purposes
                this.token = token;
                if (token) {
                  this.subscribe(subscribe, rest )
                }
                
              });
            }
            return
          }
          
          
          this.subject.next(wsres);
          wsres = null
        } catch (err) {
          console.log(err);
        }
      }
    }
  }
  reconnect() {
    
    const timeout = Math.pow(2, this.retryTimes)
    if (this.retryTimes <= 3) {
      this.retryTimes += 1
    }
    
    if (this.connectTimer) {
      clearTimeout(this.connectTimer)
    }
    this.connectTimer = setTimeout(() => {
      if(this.ws){
        this.ws.close();
      }
      this.connect()
    }, timeout * 1e3)
  }
  initHeartBeat() {
    if (this.heartBeat) {
      clearTimeout(this.heartBeat)
    }
    this.heartBeat = setTimeout(() => {
      // console.log("ws: send ping  = to keep connect alive");
      this.send('ping');
    }, 20 * 1000);
  }
  send(subject:any) {
    if (this.ws?.readyState === 1) {
      if(typeof subject === 'string') {
        this.ws?.send(subject);
      } else {
        this.ws?.send(JSON.stringify(subject));
      }
    }
  }
  /**
   * 发起订阅，如果已经订阅过，则不会重复
   * @param {*} subData
   */
  async subscribe(subname: string, subData:any) {
    if(!this.token){
      this.token = await getScopeToken(ScopeEnum.WS);
    }

    if (this.subjectMap.has(subname)) {
      // 已经订阅，暂时不做什么，允许重复
      // return;
    } else{
      const data = Object.assign({}, subData, {token: this.token});
      this.subjectMap.set(subname, [data]);
    }
    this.send({
      subscribe: subname,
      ...subData,
      token: this.token,
    });
    // 主动发起订阅时，获取token
    // getScopeToken(ScopeEnum.WS).then((token:string)=>{
      
      
    // });
    console.log("ws: send subscribe [", subname,']');
    
  }
  /**
   * 取消订阅
   * @param {*} subData
   */
  unsubscribe(subname: string, subData) {
    if (!this.subjectMap.has(subname)) {
      return;
    }
    const subItems = this.subjectMap.get(subname);
    subItems?.forEach((subData: any) => {
      console.log("ws: un-subscribe",subname, subData)
      this.send({
        subscribe: `${subname}_cancel`,
        ...subData,
      });
    });
    this.subjectMap.set(subname, []);
    // 全部取消订阅
    // const unsubscribeArgs = []
    // for (const [subTitle, subItems] of this.subjectMap) {
    //   if(subname=== subTitle){
        
    //   }
    //   // console.log("subItems(length should always=1)", subItems); 
    // }
  }
}

export const wsSubject = new WsSubject()

wsSubject.on('message', async(msg) => {
  
  const payload = JSON.parse(JSON.stringify(msg.payload));
  if(!wsSubject.token){
    wsSubject.token = await getScopeToken(ScopeEnum.WS);
  }
  const [subscribe, ...rest] = payload;

  switch (msg.type) {
    case WORKER_MSG_TOPIC.get('SUBSCRIBE'):
      if (!wsSubject.ws) {
        wsSubject.connect();
      }
      wsSubject.subscribe(subscribe, Object.assign({}, rest, {token: wsSubject.token}))
      break
    case WORKER_MSG_TOPIC.get('UNSUBSCRIBE'):
      if (!wsSubject.ws) {
        wsSubject.connect();
      }
      wsSubject.unsubscribe(...payload)
      break;
  }
});


// @ts-ignore filter((ev:any) => {NORMAL_SUBSCRIBE_MAP[ev?.group]
wsSubject.subject.pipe(filter(()=>true)).subscribe((wsData) => {
  // 全部都下发 由webworker区分处理
  
  wsSubject.emit('postMessage', {
    // @ts-ignore
    type: wsData?.subscribe, //NORMAL_SUBSCRIBE_MAP[ev.group],
    payload: wsData,
  })
});

export const eventSubject = new Subject();

